var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.075 13.685l.088-.055 11.162-5.5 12.048 16.065-5.543 7.39A11.412 11.412 0 0036.544 42.3l7.391-5.543L60 48.804l-5.454 11.07-.045.093-.056.088a3.233 3.233 0 01-2.757 1.529h-2.88a42.26 42.26 0 01-42.26-42.26v-2.881a3.233 3.233 0 011.528-2.758zm2.596 5.638c0 21.028 17.108 38.136 38.135 38.136h2.331l3.649-7.408-10.852-8.138-6.041 4.53h-.687a15.538 15.538 0 01-15.52-15.52v-.687l4.53-6.041-8.137-10.851-7.408 3.65v2.33z",
    fill: "#2E5ECC"
  })));
}

export default SvgPhoneContact;